export default __webpack_public_path__ + "static/media/liveactcover1.ffed04d8.jpg";